<template>
  <div class="tw-my-2">
    <div
      class="tw-relative tw-bg-gray-light"
      @click="selectVariant(variant)"
      @mouseover="isHover = true"
      @mouseleave="isHover = false"
    >
      <div
        class="tw-font-title tw-text-sm tw-py-5 tw-pl-3 tw-pr-12 tw-flex tw-items-center"
      >
        <div
          class="tw-pl-1 tw-pr-3 tw-flex-grow"
          v-html="variant.name"
        />
        <div class="tw-text-right tw-uppercase">
          <span v-if="variant.viewInCart">View Price In Cart</span>
          <span v-if="!variant.viewInCart">
            {{ priceString }}
            <span
              v-if="!variant.allowPurchase && !variant.viewInCart"
              class="tw-text-xs tw-font-medium"
            >
              <sup>† DSRP</sup>
            </span>
          </span>          
        </div>
      </div>
      <div
        class="button-default-noautohover tw-absolute tw-right-0 tw-top-0 tw-w-8 tw-py-4 tw-h-full tw-flex tw-items-center tw-justify-center tw-text-white"
        :class="{ 'button-default-noautohover-active': isHover }"
      >
        <stihl-icon
          name="dropdown-down-arrow"
          class="-tw-rotate-90 tw-w-4 tw-h-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pricingUtils from '@/utils/pricing-utils'
import StihlIcon from './StihlIcon.vue'

export default {
  components: {
    StihlIcon
  },
  props: {
    variant: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    priceString() {
      return '$' + pricingUtils.toDecimalPlaces(this.variant.price, 2)
    }
  },
  methods: {
    selectVariant(variant) {
      this.$emit('variant-selected', variant)
    }
  }
}
</script>


